<template>
  <div class="mobile-homepage-category-grid">
    <div class="mobile-homepage-category"
         v-for="node in getNav"
         :key="node.id+'mobile-home'"
    >
      <div class="panel panel-default">
        <div class="panel-body text-center">
          <a class="h3 text-primary"
             :href="$catLink(node.seo_link)">
            {{ node.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "mobile-home-page-categories",
    computed:{
      ...mapGetters([
          'getNav',
      ])
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/jedco/src/vue-src/top-level/mobile-home-page-categories.vue